import {
  buildPublicUserInteractionData,
  createPublicUserInteraction,
  postPublicUserInteractionMessage,
} from "InRangeAPI";
import { useTranslation } from "react-i18next";
import Button from "./Button";

const RequestUpdate = ({
  buildingPoint,
  requestedUpdate,
  setRequestedUpdate,
  buildingValidity,
  formValues,
  buildingKey,
  buildingPostcodeAddress,
}) => {
  const { t } = useTranslation("analyse");

  const handleClick = () => {
    const data = buildPublicUserInteractionData(
      formValues,
      buildingKey,
      buildingPoint,
      buildingPostcodeAddress
    );
    const companyEmail = formValues.companyEmail;
    const name = formValues.firstName + " " + formValues.lastName;
    const latitude = buildingPoint[0];
    const longitude = buildingPoint[1];
    const status = buildingValidity.size ? "INVALID_LOCATION" : "INVALID_SIZE";

    setRequestedUpdate(true);
    postPublicUserInteractionMessage(
      data,
      !buildingValidity.size ? "REQUEST_UPDATE_SMALL" : "REQUEST_UPDATE_FOREIGN"
    );
    createPublicUserInteraction(
      companyEmail,
      latitude,
      longitude,
      name,
      buildingKey,
      status
    );
  };

  return (
    <div>
      <p className="mt-3">{t("requestUpdate.prompt")}</p>
      <Button disabled={requestedUpdate} onClick={handleClick} className="mt-5">
        {requestedUpdate ? t("requestUpdate.requested") : t("requestUpdate.cta")}
      </Button>
    </div>
  );
};

export default RequestUpdate;
